import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { actions as navigationActions } from 'actions/Navigation'

import { Menu, Sidebar, Segment } from 'semantic-ui-react'

const NAV_ITEMS = [
  { name: 'Home', path: '/' },
  { name: 'Content', path: '/contents' },
  { name: 'Tags', path: '/tags' },
  { name: 'Featured', path: '/featured' },
  { name: 'Welcomes', path: '/welcomes' },
  { name: 'Polls', path: '/polls' },
  { name: 'Tips', path: '/tips' },
  { name: 'Events', path: '/events' },
  { name: 'Messages', path: '/messages' },
  { name: 'Downloads', path: '/downloads' },
  { name: 'Users', path: '/users' },
  { name: 'Conditions', path: '/conditions' },
  { name: 'Medications', path: '/medications' },
]

export class SidebarWrapper extends Component {
  handleNavClick = event => {
    const path = event.target.id
    this.props.navigate(path)
    this.props.history.push(path)
  }

  renderMenuItems() {
    return NAV_ITEMS.map((item, index) => (
      <Menu.Item
        key={item.path}
        id={item.path}
        name={item.name}
        onClick={this.handleNavClick}
      >
        {item.name}
      </Menu.Item>
    ))
  }

  render() {
    const { isDeployed, children } = this.props
    return (
      <Sidebar.Pushable as={Segment}>
        <Sidebar
          as={Menu}
          animation="push"
          width="thin"
          style={{
            backgroundColor: '#4990e1',
          }}
          visible={isDeployed}
          icon="labeled"
          vertical
          inverted
        >
          {this.renderMenuItems()}
          <Menu.Item
            name="Logout"
            onClick={() => {
              localStorage.clear()
              this.props.history.push('/login')
            }}
          >
            Logout
          </Menu.Item>
        </Sidebar>
        <Sidebar.Pusher>{children}</Sidebar.Pusher>
      </Sidebar.Pushable>
    )
  }
}

export default withRouter(
  connect(
    null,
    {
      ...navigationActions,
    },
  )(SidebarWrapper),
)
